import ApplicationMarket from '../ApplicationMarket';
import { createBEM } from 'src/util/bem';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import ApplicationMarketApi, { ApplicationMarketDOI } from '../api/applicationMarketApi';
import EnumUppercomputerType from 'src/enums/enumUppercomputerType';
import EnumOperates from 'src/enums/enumOperates';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Toast } from 'src/util/toast';
import FileUtil from 'src/util/fileUtil';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import alertApplicationMarketApiModal from '../applicationMarketModal';
let bem = createBEM('menu-btn');

export default class ApplicationMarketService extends ListPageService {
    ctx: ApplicationMarket;

    constructor(ctx: ApplicationMarket) {
        super();
        this.ctx = ctx;
    }
    

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        let ctx = t.ctx;
        return [
            {
                headerName: '上位机名称',
                field: 'file_name',
                minWidth: 300,
            },
            {
                headerName: '上位机版本',
                field: 'file_version',
                minWidth: 100,
            },
            {
                headerName: '上位机类型',
                field: 'type',
                minWidth: 130,
                cellRenderer(params) {
                    let data: ApplicationMarketDOI.RowDataI = params.data;
                    return EnumUppercomputerType.findId(data.type).getName();
                },
            },
            {
                headerName: '上位机描述',
                field: 'file_describe',
                minWidth: 900,
            },
        ]
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: CommonSelect,
                label: '上位机类型',
                field: 'type',
                labelWidth: 90,
                width:260,
                props: { value: null, dataSource: EnumUppercomputerType.getList() },
            }
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '上传',
                async onClick() {
                    let res = await alertApplicationMarketApiModal();;
                    if (res) {
                        t.searchTable();
                    }
                },
            }
        ];
    }

    async download(params) {
        let list: Array<any> = params.data.data_url.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlDownloadFile(url, params.data.file_name);
            }
        });
    }

    async delete(params) {
        let res = await Toast.confirm();
        if (!res) {
            return;
        }
        let { code } = await ApplicationMarketApi.delete(params.data.id);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<StationConfigDOI.QueryRowDataParamsI>();
    }

    @override
    async searchTable() {
        let t = this;
        let ctx = this.ctx;
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
        ag.showLoading();
        ctx.columnDefs = [
            ...this.createColumns(),
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 100,
                maxWidth: 100,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '下载',
                        click: t.download.bind(t),
                    },
                    {
                        text: '删除',
                        click: t.delete.bind(t),
                    }
                ],
            },
        ];
        let { code, data }  = await ApplicationMarketApi.userQueryList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();
        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}